<template>
    <pdf />
</template>
<script>
import Pdf from '../components/pdf'

export default {
    name: 'PdfPage',
    components: {
        Pdf
    }
}
</script>